import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Card } from 'antd'
import dayjs from 'dayjs'
import type { DropProductMovement, RouteLogResponse } from '../../../../api/useFreight/useOrderRouteLog'

interface StatsCardsProps {
  routeLog?: RouteLogResponse
}

const getTimeOfOrder = (routeLog?: RouteLogResponse) => {
  if (!routeLog || !routeLog.route || routeLog.route.length === 0) return 'N/A'

  // Ensure start is a dayjs object
  const startDate = routeLog.route[0]?.departed_for
    ? dayjs(routeLog.route[0].departed_for)
    : dayjs().subtract(96, 'minutes')

  // Ensure end is a dayjs object
  const endDate = routeLog.route[routeLog.route.length - 1]?.action_completed_at
    ? dayjs(routeLog.route[routeLog.route.length - 1].action_completed_at)
    : dayjs()

  // Safety check is still good to have
  if (!endDate || typeof endDate.diff !== 'function') return 'N/A'
  return endDate.diff(startDate, 'minutes')
}

const getDeliveredVolume = (routeLog?: RouteLogResponse) => {
  if (!routeLog || !routeLog.route) return 'N/A'

  const volumeTotal = routeLog.route
    .filter((step) => step.action === 'drop')
    .flatMap((step) => step.product_movements || [])
    // @ts-expect-error
    .reduce((acc, step) => acc + step.dropped_volume, 0)

  if (volumeTotal === 0) return 'N/A'
  return `${volumeTotal.toLocaleString()} Gallons`
}

export function StatsCards({ routeLog }: StatsCardsProps) {
  return (
    <Horizontal verticalCenter gap={16} flex={2}>
      <Card size='small' style={{ width: '80%' }}>
        <Vertical className='pl-3'>
          <Texto category='p2' appearance='light'>
            Distance
          </Texto>
          <Horizontal verticalCenter gap={6}>
            <Texto category='h5'>
              {routeLog?.route?.reduce((acc, step) => acc + step.distance_miles, 0).toFixed(2)} Miles
            </Texto>
          </Horizontal>
        </Vertical>
      </Card>

      <Card size='small' style={{ width: '80%' }}>
        <Vertical className='pl-3'>
          <Texto category='p2' appearance='light'>
            Delivered Volume
          </Texto>
          <Horizontal verticalCenter gap={6}>
            <Texto category='h5'>{getDeliveredVolume(routeLog) || 'N/A'} </Texto>
          </Horizontal>
        </Vertical>
      </Card>

      <Card size='small' style={{ width: '80%' }}>
        <Vertical className='pl-3'>
          <Texto category='p2' appearance='light'>
            Total Time
          </Texto>
          <Horizontal verticalCenter gap={6}>
            <Texto category='h5'>{getTimeOfOrder(routeLog)} MIN</Texto>
          </Horizontal>
        </Vertical>
      </Card>
    </Horizontal>
  )
}
